import { useEffect, useRef, useState } from 'react';

export const useDataGridAnimations = (isOpen?: boolean) => {
  const [animateRows, setAnimateRows] = useState(false);
  const rowAnimationTimeoutRef = useRef<number | null>(null);

  useEffect(() => {
    // If isOpen is provided, use it to control animations (for modals)
    if (isOpen !== undefined) {
      if (!isOpen) {
        setAnimateRows(false);
        return;
      }
      
      // Enable row animations when modal opens
      setAnimateRows(true);
      if (rowAnimationTimeoutRef.current !== null) {
        window.clearTimeout(rowAnimationTimeoutRef.current);
      }
      rowAnimationTimeoutRef.current = window.setTimeout(() => {
        setAnimateRows(false);
      }, 260);
    }

    return () => {
      if (rowAnimationTimeoutRef.current !== null) {
        window.clearTimeout(rowAnimationTimeoutRef.current);
      }
    };
  }, [isOpen]);

  // Manual control function for non-modal usage
  const triggerRowAnimations = () => {
    setAnimateRows(true);
    if (rowAnimationTimeoutRef.current !== null) {
      window.clearTimeout(rowAnimationTimeoutRef.current);
    }
    rowAnimationTimeoutRef.current = window.setTimeout(() => {
      setAnimateRows(false);
    }, 260);
  };

  return {
    animateRows,
    triggerRowAnimations,
  };
};